export default "__VITE_ASSET__FN7v97LG__"